// eslint-disable-next-line import/no-named-as-default
import fetch from '@/lib/authenticated-fetch'

export const apiFetch = fetch.extend({
  prefixUrl: import.meta.env.VITE_APP_API_URL,
})
